import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { getColor, responsive } from "~/helpers/style";

export const Container = styled.div`
  display: none;
  gap: 5px;
  height: 64px;
  left: 0;
  z-index: 20;
  width: 100%;
  position: fixed;
  overflow-x: auto;
  bottom: 0;
  background-color: ${getColor("white")};
  box-shadow: 0px -12px 24px 0px rgba(8, 31, 64, 0.12);

  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
  }

  ${responsive("mobileXL", true)} {
    display: flex;
  }
`;

type MenuButtonProps = {
  activeColorIcon: boolean;
  activeclassname: string;
};

export const MenuButton = styled(NavLink)<MenuButtonProps>`
  width: calc(25% - 10px);
  margin: 0 5px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none;

  ${responsive("mobileL", true)} {
    width: 25%;
    margin: 0 12px;
  }

  p {
    color: ${getColor("text")};
    width: max-content;
    text-wrap-mode: nowrap;
  }

  svg {
    color: ${getColor("text")};
  }

  &.active {
    width: fit-content;

    svg {
      color: ${getColor("primary")};
    }
    span {
      display: block;
    }
    p {
      color: ${getColor("primary")};
      font-weight: 700;
    }
  }

  :hover,
  :active,
  :focus {
    text-decoration: none;
  }
`;
export const ActiveBorder = styled.span`
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: ${getColor("primary")};
`;

export const BottomMenuImg = styled.img`
  width: 20px;
`;

export const BottomMenuText = styled.p`
  color: ${getColor("primary")};
  font-family: Nunito;
  font-size: 13px;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  margin: 0;

  ${responsive("mobileM", true)} {
    font-size: 12px;
    white-space: nowrap;
  }
`;

type AlertCircleProps = {
  top: number;
  right: number;
};

export const AlertCircle = styled.span<AlertCircleProps>`
  position: absolute;
  z-index: 1;
  top: ${(props) => `${props.top}px`};
  right: ${(props) => `calc(50% - ${props.right}px)`};
  width: 5px;
  height: 5px;
  border-radius: 10px;
  padding: 2px;
  background-color: ${getColor("primary")};
`;
